import { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";
import DateIT from "../components/DateIT";

export default function ProjectDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [newFolder, setNewFolder] = useState("");
  const [activeFolder, setActiveFolder] = useState(null);
  const [showClosed, setShowClosed] = useState(false);
  const [docs, setDocs] = useState([]);
  const [folderEmails, setFolderEmails] = useState([]);
  const [meseMassivo, setMeseMassivo] = useState("");
  const [upFile, setUpFile] = useState(null);
  const [selDocs, setSelDocs] = useState([]);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [tasks, setTasks] = useState([]);
  const [taskForm, setTaskForm] = useState(null); // {title, description, due_date}
  const [projDocs, setProjDocs] = useState([]);
  const [projUpFile, setProjUpFile] = useState(null);
  const [riepIva, setRiepIva] = useState(null);
  const [selMail, setSelMail] = useState([]);
  const [apriArchivio, setApriArchivio] = useState(false);
  const [filtroMese, setFiltroMese] = useState("");
  const [mostraFile, setMostraFile] = useState(false);
  const [zipBusy, setZipBusy] = useState(false);
  const [recBusy, setRecBusy] = useState(false);
  const [coda, setCoda] = useState([]);
  const [codaIdx, setCodaIdx] = useState(0);

  const loadProjDocs = useCallback(() => {
    api.get(`/documents?project_id=${id}`).then((r) => setProjDocs(r.data)).catch(() => {});
  }, [id]);

  const loadNotes = useCallback(() => {
    api.get(`/projects/${id}/notes`).then((r) => setNotes(r.data)).catch(() => {});
  }, [id]);

  const load = useCallback(() => {
    api.get(`/projects/${id}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [id]);

  useEffect(() => { load(); }, [load]);

  const loadTasks = useCallback((companyId) => {
    if (!companyId) return;
    api.get(`/tasks?company_id=${companyId}`).then((r) => setTasks(r.data)).catch(() => {});
  }, []);

  useEffect(() => { loadNotes(); }, [loadNotes]);
  useEffect(() => { loadProjDocs(); }, [loadProjDocs]);
  useEffect(() => { if (data?.project?.company_id) loadTasks(data.project.company_id); }, [data, loadTasks]);

  useEffect(() => {
    if (activeFolder) {
      api.get(`/documents?folder_id=${activeFolder.id}`).then((r) => setDocs(r.data)).catch(() => {});
      api.get(`/emails?folder_id=${activeFolder.id}&status=tutte`).then((r) => setFolderEmails(r.data)).catch(() => setFolderEmails([]));
      setSelDocs([]);
    } else { setDocs([]); setFolderEmails([]); setSelDocs([]); }
  }, [activeFolder]);

  useEffect(() => {
    const mesi = [...new Set(folderEmails.map((m) => (m.received_at || "").slice(0, 7)).filter(Boolean))].sort().reverse();
    setMeseMassivo((cur) => (mesi.length && !mesi.includes(cur) ? mesi[0] : cur));
  }, [folderEmails]);

  useEffect(() => {
    if (activeFolder && /fatture estere/i.test(activeFolder.name || "")) {
      api.get("/fatture-estere/riepilogo-mese").then((r) => setRiepIva(r.data)).catch(() => setRiepIva(null));
    } else setRiepIva(null);
  }, [activeFolder, folderEmails]);

  if (!data) return <p className="muted">Caricamento…</p>;
  const { project, folders } = data;

  const addFolder = async () => {
    if (!newFolder.trim()) return;
    await api.post("/projects/folders", { project_id: id, name: newFolder.trim() });
    setNewFolder(""); load();
  };
  const removeFolder = async (fid) => {
    if (!window.confirm("Eliminare la cartella? I documenti restano nell'archivio dell'azienda.")) return;
    await api.delete(`/projects/folders/${fid}`);
    if (activeFolder?.id === fid) setActiveFolder(null);
    load();
  };
  const toggleFolderClosed = async (f) => {
    await api.patch(`/projects/folders/${f.id}`, { closed: !f.closed });
    if (!f.closed && activeFolder?.id === f.id) setActiveFolder(null);
    load();
  };
  const upload = async () => {
    if (!upFile || !activeFolder) return;
    const fd = new FormData();
    fd.append("company_id", project.company_id);
    fd.append("folder_id", activeFolder.id);
    fd.append("file", upFile);
    await api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
    setUpFile(null);
    api.get(`/documents?folder_id=${activeFolder.id}`).then((r) => setDocs(r.data));
  };
  const removeDoc = async (docId) => {
    if (!window.confirm("Eliminare il documento?")) return;
    await api.delete(`/documents/${docId}`);
    api.get(`/documents?folder_id=${activeFolder.id}`).then((r) => setDocs(r.data));
  };
  const uploadProjDoc = async () => {
    if (!projUpFile) return;
    const fd = new FormData();
    fd.append("project_id", id);
    if (project.company_id) fd.append("company_id", project.company_id);
    fd.append("file", projUpFile);
    await api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
    setProjUpFile(null); loadProjDocs();
  };
  const removeProjDoc = async (docId) => {
    if (!window.confirm("Eliminare il file?")) return;
    await api.delete(`/documents/${docId}`); loadProjDocs();
  };
  const toggleDoc = (id) => setSelDocs((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const toggleAll = () => setSelDocs((s) => s.length === docs.length ? [] : docs.map((d) => d.id));
  const downloadZip = async (ids) => {
    try {
      const body = ids && ids.length ? { ids } : { folder_id: activeFolder.id };
      const res = await api.post("/documents/zip", body, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${activeFolder.name}.zip`; document.body.appendChild(a); a.click();
      a.remove(); URL.revokeObjectURL(url);
    } catch (e) { alert("Errore download: " + (e.response?.data?.detail || e.message)); }
  };
  const downloadDoc = async (d) => {
    try {
      const res = await api.get(`/documents/${d.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = d.filename || "documento"; document.body.appendChild(a); a.click();
      a.remove(); URL.revokeObjectURL(url);
    } catch (e) { alert("File non disponibile: " + (e.response?.data?.detail || e.message)); }
  };
  const toggleAcquired = async (d) => {
    await api.patch(`/documents/${d.id}`, { acquired: !d.acquired });
    setDocs((list) => list.map((x) => x.id === d.id ? { ...x, acquired: !d.acquired } : x));
  };

  const toggleScaricata = async (m) => {
    const nuovo = !m.scaricata_at;
    const r = await api.post(`/emails/${m.id}/scaricata`, { valore: nuovo });
    setFolderEmails((list) => list.map((x) => x.id === m.id ? { ...x, scaricata_at: r.data.scaricata_at } : x));
  };

  const salvaBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename; document.body.appendChild(a); a.click();
    a.remove(); URL.revokeObjectURL(url);
  };

  const reloadMails = async () => {
    const res = await api.get(`/emails?folder_id=${activeFolder.id}&status=tutte`);
    setFolderEmails(res.data); setSelMail([]);
  };

  // scarica un singolo allegato e segna la mail come scaricata
  const scaricaAllegato = async (m, i, filename) => {
    try {
      const r = await api.get(`/emails/${m.id}/attachments/${i}`, { responseType: "blob" });
      salvaBlob(r.data, filename || `allegato-${i + 1}`);
      if (!m.scaricata_at) {
        const s = await api.post(`/emails/${m.id}/scaricata`, { valore: true });
        setFolderEmails((list) => list.map((x) => x.id === m.id ? { ...x, scaricata_at: s.data.scaricata_at } : x));
      }
    } catch (e) { alert("File non disponibile: " + (e.response?.data?.detail || e.message)); }
  };

  const nelMese = (m) => !filtroMese || (m.received_at || "").slice(0, 7) === filtroMese;
  const daFare = folderEmails.filter((m) => !m.scaricata_at && nelMese(m));
  const giaFatte = folderEmails.filter((m) => !!m.scaricata_at && nelMese(m));
  const conPdf = (selMail.length ? daFare.filter((m) => selMail.includes(m.id)) : daFare).filter((m) => m.attachments_count > 0);
  const toggleMail = (id) => setSelMail((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const toggleAllMail = () => setSelMail((s) => s.length === daFare.length ? [] : daFare.map((m) => m.id));

  // ZIP di tutti gli allegati delle mail scelte: le segna scaricate da solo
  const scaricaSelezionate = async () => {
    const ids = selMail.length ? selMail : daFare.map((m) => m.id);
    if (!ids.length) return;
    setZipBusy(true);
    try {
      const r = await api.post("/emails/allegati-zip", { ids }, { responseType: "blob" });
      salvaBlob(r.data, `${activeFolder.name}-${new Date().toISOString().slice(0, 10)}.zip`);
      await reloadMails();
    } catch (e) {
      let detail = e.response?.data?.detail;
      if (e.response?.data instanceof Blob) { try { detail = JSON.parse(await e.response.data.text()).detail; } catch { /* blob non json */ } }
      alert("Errore download: " + (detail || e.message));
    } finally { setZipBusy(false); }
  };

  const segnaSelezionate = async (valore) => {
    const ids = selMail.length ? selMail : daFare.map((m) => m.id);
    if (!ids.length) return;
    await api.post("/emails/scaricata-bulk", { ids, valore });
    await reloadMails();
  };

  const senzaPdf = daFare.filter((m) => !m.attachments_count);

  // prova a tirare giù da solo i PDF dietro il link
  const recuperaPdf = async () => {
    setRecBusy(true);
    try {
      const r = await api.post("/emails/recupera-pdf", { ids: senzaPdf.map((m) => m.id), limite: 25 });
      const falliti = (r.data.dettagli || []).filter((d) => !d.ok);
      const motivi = [...new Set(falliti.map((d) => d.motivo))].slice(0, 3).join("; ");
      alert(`PDF recuperati: ${r.data.recuperati} su ${r.data.provate}.` +
        (falliti.length ? `\nNon riusciti: ${falliti.length} (${motivi}).\nQuesti vanno aperti a mano con «Apri i link».` : ""));
      await reloadMails();
    } catch (e) { alert("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setRecBusy(false); }
  };

  // apertura guidata: un link alla volta, e segna scaricata quella appena aperta
  const avviaCoda = async () => {
    try {
      const r = await api.post("/emails/link-fatture", { ids: senzaPdf.map((m) => m.id) });
      if (!r.data.length) { alert("Nessuna ricevuta da aprire a mano."); return; }
      setCoda(r.data); setCodaIdx(0);
    } catch (e) { alert("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const apriESegna = async () => {
    const item = coda[codaIdx];
    if (item?.url) window.open(item.url, "_blank", "noopener");
    if (item) await api.post(`/emails/${item.id}/scaricata`, { valore: true });
    if (codaIdx + 1 >= coda.length) { setCoda([]); setCodaIdx(0); await reloadMails(); }
    else setCodaIdx(codaIdx + 1);
  };

  const chiudiCoda = async () => { setCoda([]); setCodaIdx(0); await reloadMails(); };

  const unificata = !!activeFolder && /fatture estere/i.test(activeFolder.name || "") && folderEmails.length > 0;
  const mesiDisponibili = [...new Set(folderEmails.map((m) => (m.received_at || "").slice(0, 7)).filter(Boolean))].sort().reverse();

  const segnaMese = async (valore) => {
    const r = await api.post("/emails/scaricata-massiva", { folder_id: activeFolder.id, mese: meseMassivo, valore });
    alert(`${r.data.aggiornate} email del mese ${meseMassivo} ${valore ? "segnate come scaricate" : "riportate da scaricare"}.`);
    const res = await api.get(`/emails?folder_id=${activeFolder.id}&status=tutte`);
    setFolderEmails(res.data);
  };

  const addNote = async () => {
    if (!newNote.trim()) return;
    await api.post(`/projects/${id}/notes`, { text: newNote.trim() });
    setNewNote(""); loadNotes();
  };
  const deleteNote = async (noteId) => {
    if (!window.confirm("Eliminare l'appunto?")) return;
    await api.delete(`/projects/notes/${noteId}`);
    loadNotes();
  };
  const saveTask = async () => {
    if (!taskForm.title.trim()) return;
    await api.post("/tasks", {
      company_id: project.company_id,
      title: taskForm.title.trim(),
      description: taskForm.description || null,
      due_date: taskForm.due_date ? new Date(taskForm.due_date).toISOString() : null,
    });
    setTaskForm(null);
    loadTasks(project.company_id);
  };
  const toggleTask = async (t) => {
    await api.put(`/tasks/${t.id}`, { status: t.status === "fatto" ? "da_fare" : "fatto" });
    loadTasks(project.company_id);
  };
  const fmtDate = (s) => s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";

  return (
    <div>
      <p>{project.company_id ? <Link to={`/aziende/${project.company_id}`}>← Azienda</Link> : <Link to="/progetti">← Progetti</Link>}</p>
      <h1 className="page-title">{project.name}</h1>
      <p className="page-sub">Progetto · {project.status}</p>

      <div className="panel" data-testid="project-notes-panel">
        <h3 style={{ marginTop: 0 }}>📝 Appunti e riflessioni</h3>
        <p className="muted" style={{ marginTop: -6 }}>Annota cosa vi siete detti agli appuntamenti, idee e riflessioni. Da ogni appunto puoi far partire un incarico.</p>
        <textarea rows={3} value={newNote} onChange={(e) => setNewNote(e.target.value)} data-testid="note-input"
          placeholder="Es. Appuntamento Sciatikalia: rivisto il fatturato, valutare passaggio a regime ordinario, controllare crediti IVA…" style={{ width: "100%" }} />
        <div style={{ marginTop: 8 }}>
          <button className="btn sm primary" onClick={addNote} disabled={!newNote.trim()} data-testid="note-save-btn">Salva appunto</button>
        </div>
        <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
          {notes.map((n) => (
            <div key={n.id} className="panel" style={{ background: "rgba(255,255,255,.03)", padding: 12 }} data-testid={`note-${n.id}`}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span className="muted" style={{ fontSize: 12 }}>{fmtDate(n.created_at)} · {new Date(n.created_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</span>
                <div style={{ display: "flex", gap: 8 }}>
                  <button className="btn sm primary" onClick={() => setTaskForm({ title: "", description: n.text, due_date: "" })} data-testid={`note-task-${n.id}`}>+ Crea incarico</button>
                  <button className="btn sm danger" onClick={() => deleteNote(n.id)} data-testid={`note-del-${n.id}`}>Elimina</button>
                </div>
              </div>
              <div style={{ whiteSpace: "pre-wrap", marginTop: 6 }}>{n.text}</div>
            </div>
          ))}
          {notes.length === 0 && <span className="muted">Nessun appunto ancora.</span>}
        </div>
      </div>

      <div className="panel" data-testid="project-files-panel">
        <div className="toolbar"><h3 style={{ margin: 0 }}>📎 File del progetto</h3><div className="spacer" />
          <input type="file" style={{ maxWidth: 260 }} onChange={(e) => setProjUpFile(e.target.files[0])} data-testid="proj-file-input" />
          <button className="btn sm primary" onClick={uploadProjDoc} disabled={!projUpFile} data-testid="proj-file-upload">Carica</button>
        </div>
        <p className="muted" style={{ marginTop: -6 }}>Salva qui i file legati al progetto (vale anche per i lead, senza bisogno di un'azienda).</p>
        <table>
          <thead><tr><th>File</th><th>Dimensione</th><th></th></tr></thead>
          <tbody>
            {projDocs.map((d) => (
              <tr key={d.id} data-testid={`proj-doc-${d.id}`}>
                <td><a href="#" onClick={(e) => { e.preventDefault(); downloadDoc(d); }}>{d.filename}</a>
                  {d.related_company_name && <span className="doc-client-chip">{d.related_company_name}</span>}
                </td>
                <td>{(d.size / 1024).toFixed(0)} KB</td>
                <td><button className="btn sm danger" onClick={() => removeProjDoc(d.id)}>Elimina</button></td>
              </tr>
            ))}
            {projDocs.length === 0 && <tr><td colSpan={3} className="muted">Nessun file caricato.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="panel" data-testid="project-tasks-panel">
        <div className="toolbar"><h3 style={{ margin: 0 }}>✅ Incarichi del cliente</h3><div className="spacer" />
          <button className="btn sm primary" onClick={() => setTaskForm({ title: "", description: "", due_date: "" })} data-testid="new-task-btn">+ Nuovo incarico</button>
        </div>
        <table>
          <thead><tr><th style={{ width: 32 }}></th><th>Incarico</th><th>Scadenza</th><th></th></tr></thead>
          <tbody>
            {tasks.map((t) => (
              <tr key={t.id} data-testid={`task-${t.id}`} style={{ opacity: t.status === "fatto" ? 0.5 : 1 }}>
                <td><input type="checkbox" checked={t.status === "fatto"} onChange={() => toggleTask(t)} data-testid={`task-done-${t.id}`} /></td>
                <td><strong style={{ textDecoration: t.status === "fatto" ? "line-through" : "none" }}>{t.title}</strong>{t.description && <div className="muted" style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>{t.description}</div>}</td>
                <td className="muted" style={{ whiteSpace: "nowrap" }}>{t.due_date ? fmtDate(t.due_date) : "—"}</td>
                <td><button className="btn sm danger" onClick={async () => { if (window.confirm("Eliminare l'incarico?")) { await api.delete(`/tasks/${t.id}`); loadTasks(project.company_id); } }}>Elimina</button></td>
              </tr>
            ))}
            {tasks.length === 0 && <tr><td colSpan={4} className="muted">Nessun incarico per questo cliente.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="panel">
        <div className="toolbar"><h3 style={{ margin: 0 }}>Cartelle</h3>
          {folders.some((f) => f.closed) && (
            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }} data-testid="show-closed-folders-label">
              <input type="checkbox" checked={showClosed} onChange={(e) => setShowClosed(e.target.checked)} data-testid="show-closed-folders" />
              <span className="muted">Mostra chiuse ({folders.filter((f) => f.closed).length})</span>
            </label>
          )}
          <div className="spacer" />
          <input style={{ maxWidth: 240 }} placeholder="es. Bilancio 2026" value={newFolder} onChange={(e) => setNewFolder(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addFolder()} />
          <button className="btn sm primary" onClick={addFolder}>+ Cartella</button>
        </div>
        <div className="tag-filter">
          {folders.filter((f) => showClosed || !f.closed).map((f) => (
            <span key={f.id} className="chip" style={{ background: activeFolder?.id === f.id ? "#2563eb" : f.closed ? "#3f3f52" : "#64748b", cursor: "pointer", opacity: f.closed ? 0.7 : 1 }} onClick={() => setActiveFolder(f)} data-testid={`folder-chip-${f.id}`}>
              {f.closed ? "🔒 " : ""}{f.name}
            </span>
          ))}
          {folders.length === 0 && <span className="muted">Nessuna cartella. Creane una (es. Bilancio 2026, Equitalia, Liquidazione IVA, Consulenza).</span>}
        </div>
      </div>

      {activeFolder && (!unificata || mostraFile) && (
        <div className="panel">
          <div className="toolbar">
            <h3 style={{ margin: 0 }}>{activeFolder.closed ? "🔒 " : ""}{activeFolder.name}</h3>
            <button className="btn sm" onClick={() => toggleFolderClosed(activeFolder)} data-testid="toggle-folder-closed-btn">{activeFolder.closed ? "Riapri cartella" : "Chiudi cartella"}</button>
            <button className="btn sm danger" onClick={() => removeFolder(activeFolder.id)}>Elimina cartella</button>
            <div className="spacer" />
            {docs.length > 0 && (
              <>
                <button className="btn sm" onClick={() => downloadZip(selDocs)} disabled={selDocs.length === 0} data-testid="download-selected-btn">⬇ Scarica selezionati ({selDocs.length})</button>
                <button className="btn sm primary" onClick={() => downloadZip(null)} data-testid="download-all-btn">⬇ Scarica tutti (ZIP)</button>
              </>
            )}
            <input type="file" style={{ maxWidth: 200 }} onChange={(e) => setUpFile(e.target.files[0])} />
            <button className="btn sm primary" onClick={upload} disabled={!upFile}>Carica</button>
          </div>
          <table>
            <thead><tr>
              <th style={{ width: 28 }}><input type="checkbox" checked={docs.length > 0 && selDocs.length === docs.length} onChange={toggleAll} data-testid="select-all-docs" /></th>
              <th>File</th><th>Origine</th><th style={{ textAlign: "center" }}>Acquisita</th><th>Dimensione</th><th></th>
            </tr></thead>
            <tbody>
              {docs.map((d) => (
                <tr key={d.id} style={{ opacity: d.acquired ? 0.6 : 1 }}>
                  <td><input type="checkbox" checked={selDocs.includes(d.id)} onChange={() => toggleDoc(d.id)} data-testid={`doc-check-${d.id}`} /></td>
                  <td><a href="#" onClick={(e) => { e.preventDefault(); downloadDoc(d); }} data-testid={`doc-download-${d.id}`}>{d.filename}</a>
                    {d.related_company_name && <span className="doc-client-chip" data-testid={`doc-client-${d.id}`}>{d.related_company_name}</span>}
                  </td>
                  <td>{d.source === "email" ? "Email" : d.source === "whatsapp" ? "WhatsApp" : "Caricato"}</td>
                  <td style={{ textAlign: "center" }}>
                    <input type="checkbox" checked={!!d.acquired} onChange={() => toggleAcquired(d)} title="Già acquisita/registrata in contabilità" data-testid={`doc-acquired-${d.id}`} />
                  </td>
                  <td>{(d.size / 1024).toFixed(0)} KB</td>
                  <td><button className="btn sm danger" onClick={() => removeDoc(d.id)}>Elimina</button></td>
                </tr>
              ))}
              {docs.length === 0 && <tr><td colSpan={6} className="muted">Cartella vuota.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {activeFolder && (
        <div className="panel" data-testid="folder-emails-panel">
          <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
            <h3 style={{ margin: 0 }}>Da scaricare
              {daFare.length > 0 && <span className="chip" style={{ background: "#b45309", marginLeft: 10 }} data-testid="folder-emails-todo">{daFare.length}</span>}
            </h3>
            {filtroMese && (
              <button className="btn sm primary" onClick={() => setFiltroMese("")} data-testid="folder-emails-filter-chip">
                solo {filtroMese} ✕
              </button>
            )}
            <div className="spacer" />
            {unificata && (
              <button className="btn sm" onClick={() => setMostraFile(!mostraFile)} data-testid="folder-files-toggle">
                {mostraFile ? "Nascondi file archiviati" : `File archiviati (${docs.length})`}
              </button>
            )}
          </div>
          {riepIva && (
            <div data-testid="riepilogo-iva" style={{ background: riepIva.da_scaricare ? "#fef3c7" : "#dcfce7", color: "#1c1917", borderRadius: 10, padding: "10px 14px", margin: "10px 0 12px" }}>
              <strong>Liquidazione IVA del 16</strong> · mese {riepIva.mese}:{" "}
              {riepIva.da_scaricare
                ? <>restano <strong data-testid="riepilogo-iva-count">{riepIva.da_scaricare}</strong> ricevute da scaricare su {riepIva.totale}. <button className="btn sm" style={{ marginLeft: 8 }} onClick={() => { setFiltroMese(riepIva.mese); setMeseMassivo(riepIva.mese); setSelMail([]); }} data-testid="riepilogo-iva-goto">Mostra solo {riepIva.mese}</button></>
                : <>tutte le {riepIva.totale} ricevute del mese sono già scaricate. ✓</>}
            </div>
          )}
          {daFare.length > 0 && (
            <div className="toolbar" style={{ marginBottom: 8, gap: 8, flexWrap: "wrap" }}>
              <button className="btn sm primary" onClick={scaricaSelezionate} disabled={zipBusy || conPdf.length === 0} data-testid="folder-emails-zip">
                {zipBusy ? "Preparo lo ZIP…" : `⬇ Scarica ${selMail.length ? `le selezionate` : "tutte"} (${conPdf.length} PDF) in blocco`}
              </button>
              <button className="btn sm" onClick={() => segnaSelezionate(true)} data-testid="folder-emails-mark-sel">
                ✓ Segna scaricate {selMail.length ? `(${selMail.length})` : "tutte"}
              </button>
              {senzaPdf.length > 0 && (
                <>
                  <button className="btn sm" onClick={recuperaPdf} disabled={recBusy} data-testid="folder-emails-recupera">
                    {recBusy ? "Cerco i PDF…" : `🪄 Recupera PDF (${senzaPdf.length})`}
                  </button>
                  <button className="btn sm" onClick={avviaCoda} data-testid="folder-emails-apri-link">
                    🔗 Apri i link ({senzaPdf.length})
                  </button>
                </>
              )}
              <div className="spacer" />
              <span className="muted">Mese</span>
              <select value={meseMassivo} onChange={(e) => setMeseMassivo(e.target.value)} style={{ maxWidth: 160 }} data-testid="folder-emails-month">
                {mesiDisponibili.map((m) => <option key={m} value={m}>{m}</option>)}
              </select>
              <button className="btn sm" onClick={() => segnaMese(true)} disabled={!meseMassivo} data-testid="folder-emails-mark-month">✓ Segna il mese</button>
            </div>
          )}
          {daFare.length > 0 && (
            <p className="muted" style={{ fontSize: 12, marginTop: -4 }} data-testid="folder-emails-hint">
              Nello ZIP finiscono solo le ricevute con il PDF allegato (e vengono segnate scaricate da sole); le altre {daFare.filter((m) => !m.attachments_count).length} hanno il file dietro il link nella mail: aprile e poi usa «Segna scaricata».{" "}
              <button className="btn sm" style={{ padding: "1px 8px", fontSize: 11 }} data-testid="folder-emails-pulisci-recuperati"
                onClick={async () => {
                  if (!window.confirm("Togliere i PDF presi in automatico dai link? Le ricevute tornano senza allegato.")) return;
                  const r = await api.post("/emails/pulisci-recuperati", { folder_id: activeFolder.id });
                  alert(`${r.data.puliti} allegati recuperati tolti.`); await reloadMails();
                }}>PDF sbagliato? Togli i recuperati</button>
            </p>
          )}
          {coda.length > 0 && (
            <div data-testid="coda-link" style={{ background: "rgba(56,189,248,.1)", border: "1px solid var(--border)", borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
              <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
                <strong data-testid="coda-progress">Ricevuta {codaIdx + 1} di {coda.length}</strong>
                <div className="spacer" />
                <button className="btn sm" onClick={chiudiCoda} data-testid="coda-chiudi">Chiudi</button>
              </div>
              <div style={{ margin: "6px 0 10px" }}>
                <strong>{coda[codaIdx].from_name}</strong> · {coda[codaIdx].data}
                <div className="muted">{coda[codaIdx].subject}</div>
              </div>
              <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
                {coda[codaIdx].url ? (
                  <button className="btn sm primary" onClick={apriESegna} data-testid="coda-apri">
                    ⬈ Apri il link e segna scaricata
                  </button>
                ) : (
                  <>
                    <Link className="btn sm" to={`/email/${coda[codaIdx].id}`} data-testid="coda-apri-mail">Apri la mail (nessun link trovato)</Link>
                    <button className="btn sm" onClick={apriESegna} data-testid="coda-segna">✓ Segna scaricata e vai avanti</button>
                  </>
                )}
                <button className="btn sm" onClick={() => (codaIdx + 1 >= coda.length ? chiudiCoda() : setCodaIdx(codaIdx + 1))} data-testid="coda-salta">Salta →</button>
              </div>
            </div>
          )}
          {folderEmails.length === 0 ? (
            <p className="muted">Nessuna email abbinata. Abbina le email a questa cartella dalla sezione "Da gestire".</p>
          ) : daFare.length === 0 ? (
            <p className="muted" data-testid="folder-emails-empty">Tutto scaricato{filtroMese ? ` per ${filtroMese}` : ""}: non resta niente da prendere. ✓</p>
          ) : (
            <table data-testid="folder-emails-table">
              <thead><tr>
                <th style={{ width: 28 }}><input type="checkbox" checked={selMail.length === daFare.length} onChange={toggleAllMail} data-testid="folder-emails-select-all" /></th>
                <th>Data</th><th>Fornitore</th><th>Oggetto</th><th>Fatture / ricevute</th>
              </tr></thead>
              <tbody>
                {daFare.map((m) => (
                  <tr key={m.id} data-testid={`folder-email-${m.id}`}>
                    <td><input type="checkbox" checked={selMail.includes(m.id)} onChange={() => toggleMail(m.id)} data-testid={`folder-email-sel-${m.id}`} /></td>
                    <td className="muted" style={{ whiteSpace: "nowrap" }}>{m.received_at ? new Date(m.received_at).toLocaleDateString("it-IT") : "—"}</td>
                    <td><Link to={`/email/${m.id}`}>{m.from_name || m.from_email}</Link><div className="muted" style={{ fontSize: 12 }}>{m.from_email}</div></td>
                    <td><Link to={`/email/${m.id}`}>{m.subject || "(senza oggetto)"}</Link></td>
                    <td>
                      {(m.attachments_count > 0) ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                          {(m.attachment_names || []).map((nome, i) => (
                            <button key={i} className="btn sm" onClick={() => scaricaAllegato(m, i, nome)} data-testid={`folder-att-${m.id}-${i}`}>⬇ {nome || `allegato ${i + 1}`}</button>
                          ))}
                        </div>
                      ) : (
                        <div>
                          <span className="muted" style={{ fontSize: 12 }}>PDF dietro il link nella mail</span>
                          <div><button className="btn sm" onClick={() => toggleScaricata(m)} data-testid={`folder-email-scaricata-${m.id}`}>✓ Segna scaricata</button></div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {giaFatte.length > 0 && (
            <div style={{ marginTop: 18, borderTop: "1px solid var(--border)", paddingTop: 12 }}>
              <button className="btn sm" onClick={() => setApriArchivio(!apriArchivio)} data-testid="folder-emails-archivio">
                {apriArchivio ? "▾" : "▸"} 📁 Già scaricate ({giaFatte.length}){filtroMese ? ` · ${filtroMese}` : ""}
              </button>
              {apriArchivio && (
                <table style={{ marginTop: 10 }} data-testid="folder-emails-archivio-table">
                  <thead><tr><th>Data</th><th>Fornitore</th><th>Oggetto</th><th>Riscarica</th><th></th></tr></thead>
                  <tbody>
                    {giaFatte.map((m) => (
                      <tr key={m.id} style={{ opacity: 0.75 }} data-testid={`folder-email-done-${m.id}`}>
                        <td className="muted" style={{ whiteSpace: "nowrap" }}>{m.received_at ? new Date(m.received_at).toLocaleDateString("it-IT") : "—"}</td>
                        <td>{m.from_name || m.from_email}</td>
                        <td><Link to={`/email/${m.id}`}>{m.subject || "(senza oggetto)"}</Link>
                          <div className="muted" style={{ fontSize: 11 }}>scaricata il {new Date(m.scaricata_at).toLocaleDateString("it-IT")}</div>
                        </td>
                        <td>
                          {(m.attachments_count > 0) ? (m.attachment_names || []).map((nome, i) => (
                            <button key={i} className="btn sm" onClick={() => scaricaAllegato(m, i, nome)} data-testid={`folder-att-done-${m.id}-${i}`}>⬇ {nome || `allegato ${i + 1}`}</button>
                          )) : <span className="muted" style={{ fontSize: 12 }}>nella mail</span>}
                        </td>
                        <td><button className="btn sm" onClick={() => toggleScaricata(m)} data-testid={`folder-email-undo-${m.id}`}>↩ Rimetti da scaricare</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      )}

      {taskForm && (
        <div className="modal-overlay" onClick={() => setTaskForm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} data-testid="task-modal">
            <h3>Nuovo incarico</h3>
            <div className="field"><label>Titolo</label>
              <input value={taskForm.title} onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
                placeholder="Es. Rifare l'analisi con quanto detto e riportarla" data-testid="task-title" autoFocus /></div>
            <div className="field"><label>Dettagli / note</label>
              <textarea rows={5} value={taskForm.description} onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })} data-testid="task-desc" /></div>
            <div className="field"><label>Scadenza (es. prima del prossimo appuntamento)</label>
              <DateIT value={taskForm.due_date} onChange={(v) => setTaskForm({ ...taskForm, due_date: v })} data-testid="task-due" /></div>
            <div className="modal-actions">
              <button className="btn" onClick={() => setTaskForm(null)}>Annulla</button>
              <button className="btn primary" onClick={saveTask} disabled={!taskForm.title.trim()} data-testid="task-create-btn">Crea incarico</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
